import { AnimatePresence, motion } from "framer-motion";
import { useContext } from "react";
import styles from "./Doodle.module.css";
import { ThemeContext } from "./Wizard";

export const Doodle = () => {
  const value = useContext(ThemeContext);
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={`doodle${value}`}
        initial={{ opacity: 1 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2, delay: 0.25 }}
        className={styles[`doodle${value}`]}
      />
    </AnimatePresence>
  );
};
